export enum UserRole {
    Viewer = 0,
    Translator = 10,
    Admin = 100
}
